import React from 'react'
import { HiCode } from 'react-icons/hi'

import Service from '../assets/services.json'



function service() {
  return (
    <div className='mt-40 '>
      <h1 className=' text-gray-500 text-3xl text-center'>What i offer you 🔍</h1>
      <div className='grid grid-cols-1 md:grid-cols-2 h-max gap-10 '>
        {Service.map((service)=>(
            <div key={service.id}  className='shadow-2xl rounded-3xl p-5    mt-5'>
                <div className='flex  space-x-3 items-center flex-col'>
                    <HiCode className=' text-3xl object-cover'/>

                    <h1 className='text-gray-700 text-center text-lg space-y-0'> {service.name}</h1>
                </div>
                <div className='p-4'>
                    <p className='text-gray-700 '> {service.desc}</p>
                </div>
            </div>
        ))}
      </div>
    </div>
  )
}

export default service
